import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentNumberInUseWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.common.validation.document-number.document-number-in-use-warning');
    }
}
